import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import {personal, hackathons, openSource} from '../data/projects'
// open source: milan, planzap, url minify, pictionary
export const Projects = () => {

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item><Nav.Link eventKey="first">Personal</Nav.Link></Nav.Item>
                    <Nav.Item><Nav.Link eventKey="second">Hackathons</Nav.Link></Nav.Item>
                    <Nav.Item><Nav.Link eventKey="third">Open Source</Nav.Link></Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <p>I love to develop and indulge my mind into new things during my free time. You can view the frontend, backend, machine learning, integrations, depoloyments to cloud and various other software engineering lifecycles I follow. Each one of these projects is close to me!</p>
                      <Row>
                        {
                          personal.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>

                    <Tab.Pane eventKey="second">
                      <p>The projects that I build during national, university or community hackathons as a team participant as well as a team leader. No words can explain how much these projects have taught me in so less duration. The rush of presenting these projects on live stage is unmatched to how a developer normally feels behind the scenes.</p>
                      <Row>
                        {
                          hackathons.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>

                    <Tab.Pane eventKey="third">
                      <p>View my contributions made to open source during the JGEC Winter of Code where I stood #7 from 1500+ registered mentees. I also participated in Hacktoberfest for 2 consecutive years. I love the sentiments that open source community holds.</p>
                      <Row>
                        {
                          openSource.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>

      <img className="background-image-right" src={colorSharp2} alt="bg"/>
    </section>
  )
}
